import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckIcon, GiftIcon, ShieldCheckIcon, ClockIcon, SparklesIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { bonos, tomos } from '../data/content';
import { useCountdown } from '../hooks/useCountdown';
function TimeBox({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex w-20 flex-col items-center rounded-2xl bg-white/10 px-3 py-3 ring-1 ring-white/15" data-id="element-109" data-mp="tylcpfyphsoc">
      <span className="font-display text-3xl font-semibold tabular-nums text-white" data-id="element-110" data-mp="p0a396cbpk6n">
        {value}
      </span>
      <span className="mt-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-agua" data-id="element-111" data-mp="13xau77moxb42">
        {label}
      </span>
    </div>;
}
export function Offer() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="w-full pb-16 pt-4 sm:pb-20" aria-labelledby="oferta-title" data-id="element-112" data-mp="2famvpbuz9hn2">
      <div className="mx-auto max-w-5xl px-6" data-id="element-113" data-mp="2actp4hprilm9">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="relative overflow-hidden rounded-4xl bg-bosque px-6 py-12 text-white shadow-lift sm:px-12 sm:py-14" data-id="element-114" data-mp="pkqmy7dp7p8p">
          <span aria-hidden="true" className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-agua/15" data-id="element-115" data-mp="13ip1bcs0rlo7" />
          <span aria-hidden="true" className="pointer-events-none absolute -bottom-20 -left-14 h-56 w-56 rounded-full bg-salvia/10" data-id="element-116" data-mp="bsarbrn4mtht" />

          <div className="relative text-center" data-id="element-117" data-mp="fskw50z6ndv3">
            <p className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-agua" data-id="element-118" data-mp="km5x91w2onyi">
              🔥 Oferta especial por tiempo limitado
            </p>

            <h2 id="oferta-title" className="mt-6 font-display text-3xl font-semibold leading-tight tracking-tight sm:text-5xl" data-id="element-119" data-mp="3o8o1h02toqg9">
              🎁 Llevate los 5 bonos <span className="text-agua" data-id="element-120" data-mp="qg4jfrj9zuiv">gratis</span>,
              solo por hoy
            </h2>

            <div className="mt-8 inline-flex flex-col items-center" data-id="element-121" data-mp="1550qpmdid3if">
              <span className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-agua" data-id="element-122" data-mp="1067b9oenv2fm">
                <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-123" data-mp="cheke6cwbkrv" />
                La oferta termina en
              </span>
              <div className="flex items-center gap-2 sm:gap-3" data-id="element-124" data-mp="7k4ny6r3a8uj">
                <TimeBox value={hours} label="Horas" data-id="element-125" data-mp="lick4cgax64n" />
                <span className="font-display text-2xl text-white/40" data-id="element-126" data-mp="hg7nd4uk3tds">:</span>
                <TimeBox value={minutes} label="Min" data-id="element-127" data-mp="hic1sgq30asb" />
                <span className="font-display text-2xl text-white/40" data-id="element-128" data-mp="1wvex6xj6zdk2">:</span>
                <TimeBox value={seconds} label="Seg" data-id="element-129" data-mp="1svo2iiqjoda9" />
              </div>
            </div>
          </div>

          <div className="relative mt-10 grid gap-4 text-left lg:grid-cols-2" data-id="element-130" data-mp="20edzfas66fso">
            <div className="rounded-4xl bg-white/[0.07] p-6 ring-1 ring-white/10 sm:p-7" data-id="element-131" data-mp="25dgt5z2p8zlc">
              <h3 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.14em] text-white" data-id="element-132" data-mp="1qgpu5qwxtpw9">
                <BookOpenIcon className="h-4 w-4 text-agua" aria-hidden="true" data-id="element-133" data-mp="1vf174aij4gip" />
                Incluye el programa completo
              </h3>
              <ul className="mt-5 space-y-3" data-id="element-134" data-mp="2j5x2tiq3vvv8">
                {tomos.map(tomo => <li key={tomo.number} className="flex items-start gap-3" data-id="element-135" data-mp="2o3ovieykrm0h">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-agua" strokeWidth={2.2} aria-hidden="true" data-id="element-136" data-mp="29eak71bfuuig" />
                    <span className="text-sm leading-snug text-white/80" data-id="element-137" data-mp="322yajbb1oa2v">
                      <span className="font-semibold text-white" data-id="element-138" data-mp="36ug3bc2wz4cr">
                        {tomo.number}
                      </span>{' '}
                      — {tomo.title}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="rounded-4xl bg-agua/15 p-6 ring-1 ring-agua/30 sm:p-7" data-id="element-139" data-mp="1e9o0i577ebfi">
              <h3 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.14em] text-white" data-id="element-140" data-mp="19ab3wsqj5pzq">
                <GiftIcon className="h-4 w-4 text-agua" aria-hidden="true" data-id="element-141" data-mp="21ww66o8jnmi2" />
                🎀 5 bonos de regalo — hoy $0
              </h3>
              <ul className="mt-5 space-y-3" data-id="element-142" data-mp="1wyubf61r9yqr">
                {bonos.map((bono, index) => <li key={bono.title} className="flex items-start gap-3" data-id="element-143" data-mp="1s6b24la3pprr" data-mpi={index}>
                    <span className="mt-0.5 text-base leading-none" aria-hidden="true" data-id="element-144" data-mp="1n89dzlxtj09f">
                      🎁
                    </span>
                    <span className="text-sm leading-snug text-white/85" data-id="element-145" data-mp="2fw5b2rrauu6q">
                      <span className="font-semibold text-white" data-id="element-146" data-mp="2fuua0zp8o0jb">
                        Bono {index + 1}:
                      </span>{' '}
                      {bono.title}
                      <span className="ml-2 rounded-full bg-white/15 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-agua" data-id="element-147" data-mp="2s76c6yup74ni">
                        Gratis
                      </span>
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="relative mt-10 text-center" data-id="element-148" data-mp="3b5r0kj57fvxg">
            <div className="flex flex-col items-center justify-center gap-2 sm:flex-row sm:gap-8" data-id="element-149" data-mp="3b4fugcoaec36">
              <span className="text-lg text-white/60" data-id="element-150" data-mp="3fxsbo1qmzglw">
                Antes{' '}
                <span className="line-through decoration-agua/70 decoration-2" data-id="element-151" data-mp="3kuimoanl3m0g">
                  $49.990
                </span>
              </span>
              <span className="font-display text-5xl font-semibold tracking-tight sm:text-6xl" data-id="element-152" data-mp="3pstwildvpwio">
                $19.990
                <span className="ml-2 align-middle text-sm font-medium uppercase tracking-[0.16em] text-agua" data-id="element-153" data-mp="355cij3hlifdd">
                  hoy
                </span>
              </span>
            </div>

            <p className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-agua" data-id="element-154" data-mp="3ev5if78dl61s">
              <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-155" data-mp="3a4p65qgajqh0" />
              Ahorrás $30.000 + 5 bonos de regalo
            </p>

            <CtaButton variant="light" className="mt-7 w-full sm:w-auto" data-id="element-156" data-mp="3nv2dprp9t35t" />

            <p className="mt-5 inline-flex items-center gap-2 text-sm text-white/70" data-id="element-157" data-mp="3ix94sqwl1v1u">
              <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-158" data-mp="1ovlr0iu9uuo" />
              Acceso inmediato y de por vida
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}